import {
  ALLOWED_THIRD_PARTY_CLIENT_IDS,
  POSTCODE_REG_WHITE_LIST,
} from 'services/utils/constants/third-parties'
import { getQueryParameter } from 'services/utils/strings'
import locations from './countries'

export const isThirdParty = () => {
  const clientId = getQueryParameter('client_id')
  const isAllowed =
  ALLOWED_THIRD_PARTY_CLIENT_IDS.includes(clientId)
  return clientId && isAllowed
}
export const isPostCodeRegistration = () => {
  const origin = getQueryParameter('request_origin') || 'asda'
  return !(POSTCODE_REG_WHITE_LIST.includes(origin))
}
export const getDefaultValues = () => {
  const defaults = ['', 'ENTER_EMAIL']
  const emailFromLink = getQueryParameter('email') || ''
  const resetStep = getQueryParameter('step')
  if (emailFromLink && resetStep === 'ENTER_RESET_CODE') {
    return [emailFromLink, resetStep]
  }
  return defaults
}

export const setGhomeState = () => {
  if (getQueryParameter('request_origin') === 'voice') {
    return getQueryParameter('state')
  }
  return false
}

export const loadScript = (url) => {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = true
  script.src = url
  document.body.appendChild(script)
}

// Return the current viewport
const breakpoints = {
  small: 480,
  medium: 767,
  large: 960,
  default: 1024,
  XLarge: 1200,
}

const screenWidth = () =>
  Math.max(document.documentElement.clientWidth, window.innerWidth || 0)

const getViewPort = (screenWidth, breakpoints) => {
  const w = screenWidth()
  if (w <= breakpoints.small) {
    return 'small'
  } else if (w <= breakpoints.medium) {
    return 'medium'
  } else if (w <= breakpoints.large) {
    return 'large'
  } else if (w <= breakpoints.default) {
    return 'default'
  } else if (w <= breakpoints.XLarge) {
    return 'XLarge'
  }
  return 'XXLarge'
}

export const phoneNumberMaxLength = (countryCode = '') => {
  if (countryCode === '+91') return 10
  if (countryCode === '+44' || countryCode === '+353') return 11
  return 13
}

export const TITLETYPES = [
  'Ms',
  'Mrs',
  'Miss',
  'Mr',
  'Mx',
  'Dr',
  'Revd',
  'Lord',
  'Lady',
  'Other',
]

// Retrun the current viewport
export const getCurrentViewPort = () => getViewPort(screenWidth, breakpoints)
export const isScanAndGoUrl = !!window.location.href.match('sng_kiosk')

export { locations }
